export enum SubscriptionFeatureLimitType {
  NOT_INCLUDED,
  INCLUDED,
  MONTHLY,
  MAX,
  UNLIMITED,
}
